<template>
    <div class="lawyer-details">
        <CasesAssignLawyerModal :show_assign_lawyer.sync="modals.show_assign_lawyer" />
        <b-row no-gutters>
            <b-col cols="12" md="6">
                <b-row>
                    <b-col cols="12" class="mb-2">
                        <p class="text-truncate">{{ spa_lawyer.name || 'N/A' }}</p>
                        <p class="text-xs text-muted text-truncate">{{ spa_lawyer.company || 'Lawyer not yet assigned.' }}</p>
                    </b-col>
                    <b-col cols="12">
                        <div class="bg-dark p-2 border">
                            <p class="font-weight-500 text-white">SPA Tracking</p>
                        </div>
                        <div class="timeline py-3">
                            <div class="block">
                                <el-timeline :key="keys.spa_timeline">
                                    <el-timeline-item
                                        v-for="(activity, index) in spa_trackings"
                                        :key="index"
                                        :icon="activity.icon"
                                        :type="activity.type"
                                        :color="activity.color"
                                        :size="activity.size"
                                        :timestamp="activity.timestamp"
                                    >
                                        {{activity.content}}
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6">
                <b-row>
                    <b-col cols="12" class="mb-2">
                        <p>{{ la_lawyer.name || 'N/A' }}</p>
                        <p class="text-xs text-muted">{{ la_lawyer.company || 'Lawyer not yet assigned.' }}</p>
                    </b-col>
                    <b-col cols="12">
                        <div class="bg-dark p-2 border">
                            <p class="font-weight-500 text-white">LA Tracking</p>
                        </div>
                        <div class="timeline py-3">
                            <div class="block">
                                <el-timeline :key="keys.la_timeline">
                                    <el-timeline-item
                                        v-for="(activity, index) in la_trackings"
                                        :key="index"
                                        :icon="activity.icon"
                                        :type="activity.type"
                                        :color="activity.color"
                                        :size="activity.size"
                                        :timestamp="activity.timestamp"
                                    >
                                        {{activity.content}}
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!-- <b-col cols="12" class="text-center">
                <p>There is no lawyer currently assigned to this project</p>
                <el-button @click="modals.show_assign_lawyer = true" class="text-primary" type="text">+ Assigned Lawyer</el-button>
            </b-col> -->
        </b-row>
    </div>
</template>
<script>
import { Timeline, TimelineItem, Button } from 'element-ui'
import CasesAssignLawyerModal from '@/views/CustomerProfile/CustomerModals/CasesAssignLawyerModal'
import moment from 'moment'

export default {
    props: ['lawyer_details', 'is_hestia'],
    components: {
        CasesAssignLawyerModal,
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
        [Button.name]: Button,
    },
    data() {
      return {
            modals: {
                show_assign_lawyer: false
            },
            spa_lawyer:{
                name:'',
                company:'',
            },
            la_lawyer:{
                name:'',
                company:'',
            },
            spa_trackings: [{
                content: 'Pending Appointment',
                size: 'large',
                value: 1,
            }, {
                content: 'SPA Signed',
                size: 'large',
                value: 2,
            }, {
                content: 'SPA Received',
                size: 'large',
                value: 3,
            }, {
                content: 'Developer Signed',
                size: 'large',
                value: 4,
            }, {
                content: 'Lawyer Collected',
                size: 'large',
                value: 5,
            }, {
                content: 'SPA Stamped',
                size: 'large',
                value: 6,
            },{
                content: 'Vacant Possession',
                size: 'large',
                value: 7,
            }],
            la_trackings: [{
                content: 'New',
                size: 'large',
                value: 8,
            }, {
                content: 'LA Signed by Borrower',
                size: 'large',
                value: 9,
            }, {
                content: 'LA Signed by Bank',
                size: 'large',
                value: 10,
            }, {
                content: 'LOU Signed & Issued',
                size: 'large',
                value: 11,
            },{
                content: 'LA Stamped',
                size: 'large',
                value: 12,
            }, {
                content: 'Advice Bank for 1st Draw Down',
                size: 'large',
                value: 13,
            }, {
                content: 'First Disbursement',
                size: 'large',
                value: 14,
            }, {
                content: 'Full Disbursement',
                size: 'large',
                value: 15,
            }],
            default_spa_trackings: [{
                content: 'Pending Appointment',
                size: 'large',
                value: 1,
            }, {
                content: 'SPA Signed',
                size: 'large',
                value: 2,
            }, {
                content: 'SPA Received',
                size: 'large',
                value: 3,
            }, {
                content: 'Developer Signed',
                size: 'large',
                value: 4,
            }, {
                content: 'Lawyer Collected',
                size: 'large',
                value: 5,
            }, {
                content: 'SPA Stamped',
                size: 'large',
                value: 6,
            },{
                content: 'Vacant Possession',
                size: 'large',
                value: 7,
            }],
            default_la_trackings: [{
                content: 'New',
                size: 'large',
                value: 8,
            }, {
                content: 'LA Signed by Borrower',
                size: 'large',
                value: 9,
            }, {
                content: 'LA Signed by Bank',
                size: 'large',
                value: 10,
            }, {
                content: 'LOU Signed & Issued',
                size: 'large',
                value: 11,
            },{
                content: 'LA Stamped',
                size: 'large',
                value: 12,
            }, {
                content: 'Advice Bank for 1st Draw Down',
                size: 'large',
                value: 13,
            }, {
                content: 'First Disbursement',
                size: 'large',
                value: 14,
            }, {
                content: 'Full Disbursement',
                size: 'large',
                value: 15,
            }],
            keys:{
                la_timeline: 1,
                spa_timeline: 1
            }
        }
    },
    watch:{
        lawyer_details(newVal){
            this.spa_trackings = JSON.parse(JSON.stringify(this.default_spa_trackings))
            this.la_trackings = JSON.parse(JSON.stringify(this.default_la_trackings))
            if(this.is_hestia)
            {
                newVal.spa.trackings.forEach((pmp_tracking) =>{
                    this.spa_trackings.forEach((spa_tracking) => {
                        if(pmp_tracking.tracking_stage_id === spa_tracking.value){
                            spa_tracking.color = '#0bc196'
                            spa_tracking.icon = 'el-icon-check'
                            spa_tracking.timestamp = moment(pmp_tracking.created_at).format('D MMM, YYYY h:mm A')
                        }

                        if(pmp_tracking.tracking_stage_id === spa_tracking.value && spa_tracking.value === 2){
                            spa_tracking.timestamp = moment(newVal.spa.signed_date).format('D MMM, YYYY h:mm A')
                        }
                    })
                })

                this.keys.spa_timeline++

                // check la tracking
                newVal.la.trackings.forEach((pmp_tracking) =>{
                    this.la_trackings.forEach((la_tracking) => {
                        if(pmp_tracking.tracking_stage_id === la_tracking.value){
                            la_tracking.color = '#0bc196'
                            la_tracking.icon = 'el-icon-check'
                            la_tracking.timestamp = moment(pmp_tracking.created_at).format('D MMM, YYYY h:mm A')
                        }

                        if(pmp_tracking.tracking_stage_id === la_tracking.value && la_tracking.value === 9){
                            la_tracking.timestamp = moment(newVal.la.signed_date).format('D MMM, YYYY h:mm A')
                        }
                    })
                })

                this.keys.la_timeline++

                // check spa lawyer
                const spa_lawyer = newVal.spa.lawyer
                if(spa_lawyer){
                    this.spa_lawyer.name = spa_lawyer.solicitor_name
                    this.spa_lawyer.company = spa_lawyer.business_reg_no
                } else {
                    this.spa_lawyer.name = ''
                    this.spa_lawyer.company = ''
                }

                // check la lawyer
                const la_lawyer = newVal.la.lawyer
                if(la_lawyer){
                    this.la_lawyer.name = la_lawyer.solicitor_name
                    this.la_lawyer.company = la_lawyer.business_reg_no
                }  else {
                    this.la_lawyer.name = ''
                    this.la_lawyer.company = ''
                }
            }
            else
            {
                newVal.spa.trackings.forEach((pmp_tracking) =>{
                    this.spa_trackings.forEach((spa_tracking) => {
                        if(pmp_tracking.tracking_stages_id === spa_tracking.value){
                            spa_tracking.color = '#0bc196'
                            spa_tracking.icon = 'el-icon-check'
                            spa_tracking.timestamp = moment(pmp_tracking.created_at).format('D MMM, YYYY h:mm A')
                        }
    
                        if(pmp_tracking.tracking_stages_id === spa_tracking.value && spa_tracking.value === 2){
                            spa_tracking.timestamp = moment(newVal.spa.signed_date).format('D MMM, YYYY h:mm A')
                        }
                    })
                })
    
                this.keys.spa_timeline++
                    
                // check la tracking
                newVal.la.trackings.forEach((pmp_tracking) =>{
                    this.la_trackings.forEach((la_tracking) => {
                        if(pmp_tracking.tracking_stages_id === la_tracking.value){
                            la_tracking.color = '#0bc196'
                            la_tracking.icon = 'el-icon-check'
                            la_tracking.timestamp = moment(pmp_tracking.created_at).format('D MMM, YYYY h:mm A')
                        }
    
                        if(pmp_tracking.tracking_stages_id === la_tracking.value && la_tracking.value === 9){
                            la_tracking.timestamp = moment(newVal.la.signed_date).format('D MMM, YYYY h:mm A')
                        }
                    })
                })
    
                this.keys.la_timeline++

                // check spa lawyer
                const spa_lawyer = newVal.spa.lawyer
                if(spa_lawyer){
                    this.spa_lawyer.name = spa_lawyer.fullname
                    this.spa_lawyer.company = spa_lawyer.company_name
                } else {
                    this.spa_lawyer.name = ''
                    this.spa_lawyer.company = ''
                }

                // check la lawyer
                const la_lawyer = newVal.la.lawyer
                if(la_lawyer){
                    this.la_lawyer.name = la_lawyer.fullname
                    this.la_lawyer.company = la_lawyer.company_name
                }  else {
                    this.la_lawyer.name = ''
                    this.la_lawyer.company = ''
                }
            }
        }
    },
}
</script>